export default class DeleteSeatButton {
    constructor(props, buttonSelector) {
        this.props = props;
        this.dataStorage = this.props.dataStorage;
        // Iterate over each button and bind the click event
        $(buttonSelector).each((index, button) => {
            $(button).on('click', async (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                this.props._showLoader();
                const elements = getTicketElements(button);
                if (!elements) {
                    console.error('Could not fetch all required ticket elements.');
                    return;
                }

                const response = await fetch("/cart/RemoveTicket", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: new URLSearchParams({ id: elements.ticketId })
                });
                this.props._hideLoader();
                if (response.ok) {
                    // Wait for dataStorage to be updated before reloading
                    this.props.dataStorage.init().done(() =>
                    {
                        // Remove tickets from the DOM that no longer exist in dataStorage.cart
                        this.syncDOMWithCart();
                        const startEvent = new Event("cartUpdateEvent");
                        document.dispatchEvent(startEvent);
                        this.props.reloadCart();
                    });
                } else {
                    console.error('Error removing ticket');
                }
            });
        });
        function getTicketElements(button) {
            const ticketId = $(button).data('ticket-id');
            if (!ticketId) return false;

            const row = document.querySelector(`tr[data-ticket-id="${ticketId}"]`);
            if (!row) return false;

            const ticketType = row.getAttribute('data-ticket-type');
            if (!ticketType) return false;

            const table = document.querySelector(`table[data-ticket-type="${ticketType}"]`);
            if (!table) return false;

            // Return all relevant elements if everything checks out
            return {
                ticketId,
                row,
                ticketType,
                table
            };
        }
    }

    /**
     * Synchronize the DOM with the updated dataStorage.cart.
     * Remove any tickets in the DOM that are no longer present in dataStorage.cart.
     */
    syncDOMWithCart() {
        const cartTicketIds = new Set(this.dataStorage.cart.map(ticket => ticket.id));
        $('.ticket-type-table').each(function () {
            const $table = $(this);
            const $rows = $table.find('tbody tr.seat');

            $rows.each(function () {
                const $row = $(this);
                const ticketId = $row.data('ticket-id');

                if (!cartTicketIds.has(ticketId)) {
                    $row.remove();
                }
            });

            if ($table.find('tbody tr.seat').length === 0) {
                $table.remove();
            }
        });

    }
}
